import React from 'react';
import BackButton from './BackButton/BackButton';

const PageHeader = ({ hasBack = true, title, onBack }) => {
	return (
		<div className="flex items-center gap-6">
			{hasBack ? <BackButton onClick={onBack} /> : null}
			<h1 className="text-[20px] font-bold inline-block font-proxima">{title}</h1>
		</div>
	);
};

export default PageHeader;
